import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03a4a9c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_2 = {
  id: "form-product-put-avatar",
  class: "card p-4 d-flex"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "row g-4 mt-1" }
const _hoisted_5 = { class: "col-9" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-product-post-url",
  class: "btn background_btn_1_opct w-100"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-upload",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Imagem ")
], -1))
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt m-0 p-0",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "card p-4" }
const _hoisted_12 = { class: "row g-4" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "*", -1))
const _hoisted_15 = { class: "col-md-9" }
const _hoisted_16 = {
  for: "form-product-put-nome",
  class: "form-label cor_texto_1"
}
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = {
  for: "form-product-put-sku",
  class: "form-label cor_texto_1"
}
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = { class: "col-md-10" }
const _hoisted_22 = {
  for: "form-product-put-categoria",
  class: "form-label cor_texto_1"
}
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = { class: "col-md-2" }
const _hoisted_25 = {
  for: "form-prouct-post-default-points",
  class: "form-label cor_texto_1"
}
const _hoisted_26 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-product-put-descricao",
  class: "form-label cor_texto_1"
}, "Descrição: ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn background_btn_1",
  style: {"color":"var(--cor_icones_1)"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-save",
    style: {"color":"var(--cor_icones_1)"},
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Salvar ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CampHeader = _resolveComponent("CampHeader")!
  const _component_CampCropImageLoader = _resolveComponent("CampCropImageLoader")!
  const _component_CampCropImageRack = _resolveComponent("CampCropImageRack")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CampFormRackSubmitBtn = _resolveComponent("CampFormRackSubmitBtn")!
  const _component_ModalSavePointsAllStores = _resolveComponent("ModalSavePointsAllStores")!
  const _component_CampModalCropImage = _resolveComponent("CampModalCropImage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CampHeader, null, {
      title: _withCtx(() => [
        _createTextVNode("Editar Pré-Cadastro de Produto")
      ]),
      button: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: `/produtos`,
          class: "btn btn_background_1"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(" Voltar ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.productFields && _ctx.categoryField)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isRequiredField=false))
        }, [
          _createElementVNode("form", {
            class: "gap-4",
            id: "form-product-put",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.showModalSavePoints = true), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_CampCropImageRack, { style: {"position":"relative"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_CampCropImageLoader, { isLoading: _ctx.productImgIsLoading }, null, 8, ["isLoading"]),
                  _createElementVNode("img", {
                    onLoad: _cache[0] || (_cache[0] = () => _ctx.productImgIsLoading = false),
                    src: _ctx.productImgURL,
                    style: {"z-index":"0","object-fit":"contain","width":"100%","height":"100%","top":"0"},
                    alt: "Imagem Selecionada"
                  }, null, 40, _hoisted_3)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("input", {
                    type: "file",
                    class: "d-none",
                    id: "form-product-post-url",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleImgFileChange && _ctx.handleImgFileChange(...args)))
                  }, null, 32)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileRemoval && _ctx.handleFileRemoval(...args))),
                    class: "btn background_btn_1_opct w-100 px-0",
                    disabled: _ctx.CampUploadImgURL != _ctx.productImgURL ? false : true
                  }, _hoisted_10, 8, _hoisted_8)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.isRequiredField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createTextVNode(" Preencha os campos marcados com "),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, [
                    _createTextVNode("Nome interno: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_17, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.productFields.name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.productFields.name) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-product-put-nome",
                    id: "form-product-put-nome",
                    placeholder: "Digite o nome..."
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, [
                    _createTextVNode("SKU: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_20, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.productFields.sku,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.productFields.sku) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-product-put-sku",
                    id: "form-product-put-sku",
                    placeholder: "Digite o SKU..."
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, [
                    _createTextVNode("Categoria: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_23, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_select, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isRequiredField=false)),
                    id: "form-product-put-categoria",
                    filterable: "",
                    "allow-create": "",
                    "default-first-option": "",
                    "reserve-keyword": false,
                    placeholder: "Selecione a categoria...",
                    style: {"margin-top":"0","width":"100%"},
                    modelValue: _ctx.productFields.id_category,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.productFields.id_category) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryField, (el) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: el.id,
                          value: el.id,
                          label: el.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, [
                    _createTextVNode("Pontos: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_26, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    min: "0.1",
                    step: "0.1",
                    modelValue: _ctx.productFields.points_default,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.productFields.points_default) = $event)),
                    type: "number",
                    name: "form-prouct-post-default-points",
                    id: "form-prouct-post-default-points"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.productFields.description,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productFields.description) = $event)),
                    clearable: "",
                    type: "textarea",
                    rows: 7,
                    name: "form-product-put-descricao",
                    id: "form-product-put-descricao",
                    placeholder: "Digite uma descrição..."
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createVNode(_component_CampFormRackSubmitBtn, {
              gapTop: 40,
              style: {"grid-column":"1 / -1"}
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }),
            _createVNode(_component_ModalSavePointsAllStores, {
              name: _ctx.productFields.name,
              storeListBySku: _ctx.storeListBySku,
              handleButtonClick: _ctx.onSubmitFormAllStores,
              "handle-button-click-false": _ctx.onSubmitForm,
              toggle: _ctx.showModalSavePoints,
              onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showModalSavePoints = false))
            }, null, 8, ["name", "storeListBySku", "handleButtonClick", "handle-button-click-false", "toggle"])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CampModalCropImage, {
      maxFileSizeMD: 2,
      canvasWidth: 1920,
      canvasHeight: 1080,
      thumbnailWidth: 200,
      thumbnailHeight: 200,
      sizeCanvasFixed: false,
      productImgFile: _ctx.productImgFile,
      onGetImgResults: _ctx.handleCroppedImgBase64
    }, null, 8, ["productImgFile", "onGetImgResults"])
  ], 64))
}